"use strict";

function helper(Handlebars) {
  /**
   * Access Math methods and apply them to arguments, e.g. Math.abs, Math.random
   *
   * {{math "<any-method-on-Math>" arg1 arg2 ...}}
   *
   * {{math "abs" -1}} returns 1
   * {{math "round" 1.75}} returns 2
   * {{math "min" 3 -1 2}} returns -1
   *
   *
   * @return {String} Result of applying Math.<function> on the arguments
   */
  function math() {
    for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
      arg[_key] = arguments[_key];
    }
    var args = Array.prototype.slice.call(arg, 0, -1);
    var method = args.shift();
    if (typeof Math[method] !== 'function') {
      return '';
    }
    var result = Math[method].apply(null, args);

    // eslint-disable-next-line no-restricted-globals
    return isNaN(result) ? '' : result;
  }
  Handlebars.registerHelper('math', math);
  return math;
}
module.exports = helper;
